export const formatOrderServiceIdLabel = orderServiceId => {
  if (!orderServiceId) {
    return null;
  }
  const text = String(orderServiceId);
  return text.length > 24 ? `${text.slice(0, 21)}...` : text;
};

export const getDocumentLabel = item => {
  switch (item?.reswareDocumentTypeId) {
    case 1333:
      return 'BMA 1';
    case 1334:
      return 'BMA 2';
    case 1335:
      return 'BMA 3';
    case 40: {
      const serviceId = formatOrderServiceIdLabel(item?.orderServiceId);
      return serviceId ? `Appraisal (${serviceId})` : 'Appraisal';
    }
    default:
      return 'Unknown Doc Type Id';
  }
};
